import { environment as env } from "../../../../../environments/environment";

const BASE_API_URL = env.ApiUrl + "api/"; // env.apiGateWayAdmin;
// const BASE_API_URL = "http://localhost:3000/" + "api/"; // env.apiGateWayAdmin;
// const ADMIN_BASE_API_URL = env.ApiUrl; //env.apiGateWayAdmin;

export const COMPANY_ENDPOINTS = {
    base: BASE_API_URL,
    list: `${BASE_API_URL}company`,
    item: `${BASE_API_URL}company/{id}`,
    itemList: `${BASE_API_URL}company/{id}/list`,
    listParents: `${BASE_API_URL}company/parents`,
};

export const CONTACT_ENDPOINTS = {
    base: `${BASE_API_URL}company/{companyId}/contacts`,
    list: `${BASE_API_URL}company/{companyId}/contacts`,
    item: `${BASE_API_URL}company/{companyId}/contacts/{id}`,
};

export const USER_ENDPOINTS = {
    base: `${BASE_API_URL}company/{id}/users`,
    list: `${BASE_API_URL}company/{id}/users`,
    item: `${BASE_API_URL}company/{companyId}/users/{id}`,
    activation: `${BASE_API_URL}company/{companyId}/users/{id}/activationToggle`,
    unlock: `${BASE_API_URL}company/user/unlock`,
};

export const APP_ENDPOINTS = {
    list: `${BASE_API_URL}company/{companyId}/apps`,
    base: `${BASE_API_URL}company/{companyId}/apps`,
    item: `${BASE_API_URL}company/{companyId}/apps/{id}`,
    activation: `${BASE_API_URL}company/{companyId}/apps/{id}/status`,
};

export const COMPANY_USER_ENDPOINTS = {
    list: `${BASE_API_URL}users`,
    base: `${BASE_API_URL}users`,
    item: `${BASE_API_URL}users`,
};

export const COMPANY_OPERATOR_ENDPOINTS = {
    list: `${BASE_API_URL}organization/{companyId}/operator`,
    list_short_codes: `${BASE_API_URL}organization/{companyId}/operator/{operatorId}/short_codes`,
};

export const CONTACT_RULE_ENDPOINTS = {
    base: `${BASE_API_URL}organization/contactability`,
    list: `${BASE_API_URL}organization/{companyId}/contactability`,
    item: `${BASE_API_URL}organization/contactability/{id}`,
};
